<template>
  <b-modal :id="modalId" :title="title" hide-footer no-close-on-backdrop>
    <b-tabs content-class="mt-3" v-if="selectedDownload">
      <b-tab title="Edit Download">
        <download-form
          v-if="selectedDownload"
          @hasUpdate="$emit('hasUpdate')"
          :download="selectedDownload"
        />
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script>
import DownloadForm from "../Forms/DownloadForm";
import config from "../../constants/config";
import { mapGetters } from "vuex";

export default {
  name: "VersionModal",
  components: {
    DownloadForm
  },
  computed: {
    ...mapGetters("product", ["selectedDownload"]),
    modalId() {
      return config.DOWNLOAD_MODAL_ID;
    },
    title() {
      return this.selectedDownload ? this.selectedDownload.name : "";
    }
  }
};
</script>
